module.exports = __webpack_public_path__ + "img/BN.35e14c11.png";